<div class="dhhpCardContain mb-2">
    <mat-card class="p-3 profile-common-card-container">
        <div class="d-flex justify-content-between mb-2" *ngIf="enableServiceView">
            <div class="form-group">
                <div class="message-icon">
                    <mat-button-toggle-group name="" aria-label="" [(ngModel)]="serviceType" (ngModelChange)="serviceTypeChange($event)">
                        <mat-button-toggle [value]="'serviceSubscription'">
                            {{'Servicessubscriptions'|translate}}
                        </mat-button-toggle>
                        <mat-button-toggle [value]="'appSubscription'">{{'Services'|translate}}
                        </mat-button-toggle>
                    </mat-button-toggle-group>
                </div>
            </div>
            <div class="col-auto pr-0" *ngIf="serviceView">
                <div class="input-group">
                    <input matInput (keyup)="applyFilter($event.target.value)" [(ngModel)]="searchValue" class="form-control my-0 py-1 mdisplay search-patient"
                        type="text" placeholder="{{'Search' | translate}}" aria-label="Search">
                    <div class="input-group-append">
                        <span class="input-group-text red lighten-3" id="basic-text1">
                            <mat-icon *ngIf="!searchValue">search</mat-icon>
                            <mat-icon *ngIf="searchValue" (click)="removeSearchText()" style="cursor: pointer">close
                            </mat-icon>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="table-responsive" *ngIf="serviceView && enableServiceView">
            <table #table mat-table class="border1" matSort [dataSource]="servicedataSource" style="width: 100%;">
                <tr mat-header-row *matHeaderRowDef="serviceDisplayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: serviceDisplayedColumns;"></tr>
                <ng-container matColumnDef="serviceName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'Servicesname'|translate}}</th>
                    <td mat-cell *matCellDef="let element">
                        <div class="cursor" (click)="getRecord(element)">
                            {{element.serviceName}}
                        </div>
                    </td>
                </ng-container>
                <ng-container matColumnDef="serviceId">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'ServicesID'|translate}} </th>
                    <td mat-cell *matCellDef="let element">
                        <div class="cursor" (click)="getRecord(element)">
                            {{element.serviceId}}
                        </div>
                    </td>
                </ng-container>
                <ng-container matColumnDef="versoin">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'Version'|translate}} </th>
                    <td mat-cell *matCellDef="let element">
                        <div class="cursor" (click)="getRecord(element)">
                            {{element.versoin}}
                        </div>
                    </td>
                </ng-container>
                <ng-container matColumnDef="secretKey">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'Secretkey'|translate}} </th>
                    <td mat-cell class="cursor" *matCellDef="let element;let i=index">
                        <div class="cpycls">
                            <input type="text" class="form-control secret-key" [attr.id]="copyInput+i" [value]="element.secretKey">
                            <span class="cursor d-flex align-items-center secret-key-copy ml-2" style="color: #007bff;" (click)="copyText(i)">Copy</span>
                        </div>
                    </td>
                </ng-container>
            </table>
            <div [hidden]="!showPagination">
                <mat-paginator [ngClass]="{ 'hide-paginates': isNotFound}" class="float-left" [pageSizeOptions]="[10, 20, 30, 40, 50]" showFirstLastButtons></mat-paginator>
            </div>
            <mat-card *ngIf="isNotFound" class="noRec">
                <p>{{'NoRecFound'|translate}} </p>
            </mat-card>
        </div>
        <h3 class="mb-16" *ngIf="!this.enableServiceView">{{'Services'|translate}}</h3>
        <mat-divider class=""></mat-divider>
        <div class="table-responsive border mt-4" *ngIf="appView">
            <table #table mat-table class="border1" [dataSource]="dataSource" style="width: 100%;">
                <ng-container matColumnDef="appName">
                    <th mat-header-cell *matHeaderCellDef> {{'ServiceName'|translate}}</th>
                    <td mat-cell *matCellDef="let element"> {{translate.instant(getAppName(element))}} </td>
                </ng-container>
                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef> {{'Status'|translate}} </th>
                    <td mat-cell *matCellDef="let element">
                        <div>
                            <span class="d-flex align-items-center" *ngIf="element.status == 'Approved'">
                                <span style="color:#28a745!important;font-size: 18px; " class="material-icons mr-2 "> check_circle_outline</span> {{translate.instant(element.status)}}
                            </span>
                            <span class="d-flex align-items-center" *ngIf="element.status == 'Pending Approval'">
                                <mat-icon style="width:18px;" class=" mr-2" svgIcon="pending_icon"></mat-icon>
                                {{element.status}}
                            </span>
                        </div>
                    </td>
                </ng-container>
                <ng-container matColumnDef="facilityName">
                    <th mat-header-cell *matHeaderCellDef> {{'Site'|translate}}</th>
                    <td mat-cell *matCellDef="let element">
                        <span *ngIf="showRequest"> {{element.facilityName?element.facilityName:'--'}} </span>
                        <span *ngIf="!showRequest">
                            <img src="assets/img/profile/not-available.png" alt="Not applicable"> </span>
                    </td>
                </ng-container>
                <ng-container matColumnDef="action">
                    <th class="pl-4" mat-header-cell *matHeaderCellDef>{{'Action'|translate}} </th>
                    <td class="pl-4" mat-cell *matCellDef="let element">
                        <div class="d-flex justify-content-center1" *ngIf="element.status == 'Approved'">
                            <div class="round-corner-gray cursor" *ngIf="!hideSubscribe" (click)="unsubscribeApp(element)">
                                <span class="cart-color d-flex align-items-center">
                                    <i style="font-size: 20px;" class="material-icons mr-2">
                                        remove_circle_outline
                                    </i>{{'Unsubscribe'|translate}}</span>
                            </div>
                            <div *ngFor="let innerItem of element.applicationSettings; let it = index;">
                                <div class="round-corner cursor" *ngIf="showRequest && innerItem.country == countryVal && innerItem.isPaidApp">
                                    <span (click)="getSubscription(element)" *ngIf="innerItem.isPaidApp">{{'Request-Plan'|translate}}</span>
                                </div>
                            </div>
                            <div *ngFor="let innerItem of element.applicationSettings; let it = index;">
                                <div class="round-corner cursor" *ngIf="showRequest && innerItem.country == countryVal">
                                    <span (click)="viewServiceAgreement(element)" *ngIf="innerItem.isPaidApp">{{'serviceagreement'|translate}}</span>
                                </div>
                            </div>
                        </div>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
            <mat-card class="border" *ngIf="isNotFound">
                <p class="text-center norecords">{{'NoRecfound' | translate}}</p>
            </mat-card>
        </div>
    </mat-card>
</div>